module.exports = __webpack_public_path__ + "img/YouPlusAnchorChallenger2020EN-4.c5296a13.jpg";